import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-page max-w-3xl">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full mb-4">
            <i className="ri-question-answer-line"></i> 常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            你可能想 <span className="text-primary-500">了解</span> 的
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">{faq.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center shrink-0 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-60 pb-4" : "max-h-0"
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}